import { Badge } from '~/shared/components/Badge';
import { Button } from '~/shared/components/buttons/Button';
import { DataTable } from '~/shared/data-tables/DataTable';
import type { DiagnosisDraft } from '../types';
import type { DataTableColumnProps } from '~/shared/data-tables/DataTableColumn';

export function EditDiagnosesTable({
	rows,
	onSorted,
	onEdit,
	onRemove
}: {
	rows: DiagnosisDraft[];
	onSorted: (ids: (string | number)[]) => void;
	onEdit: (row: DiagnosisDraft) => void;
	onRemove: (row: DiagnosisDraft) => void;
}) {
	const columns: DataTableColumnProps<DiagnosisDraft>[] = [
		{
			key: 'code',
			header: 'ICD',
			width: 'w-24',
			renderCell: d => (
				<div className="flex items-center gap-1.5">
					<span className="font-mono text-xs font-semibold text-gray-800">{d.code}</span>
					{d.order === 1 && <Badge intent="success">Primary</Badge>}
				</div>
			)
		},
		{
			key: 'description',
			header: 'Description',
			cellClassName: 'text-sm text-gray-800',
			renderCell: d => d.description
		},
		{
			key: 'symptomControlRatingLabel',
			header: 'SCR',
			whitespaceNowrap: true,
			cellClassName: 'text-xs text-gray-500',
			renderCell: d => d.symptomControlRatingLabel.split(' - ')[0]
		},
		{
			header: 'Onset Date',
			key: 'onsetDate',
			renderCell: d => (d.onsetDate ? new Date(d.onsetDate).toLocaleDateString() : 'N/A')
		},
		{
			key: 'actions',
			renderCell: d => (
				<div className="flex justify-end gap-1">
					<Button actionType="edit" appearance="outline" onClick={() => onEdit(d)} />
					<Button actionType="delete" appearance="outline" onClick={() => onRemove(d)} />
				</div>
			)
		}
	];

	return <DataTable columns={columns} rows={rows} getRowId={d => d.key} allowDragAndDrop onSorted={onSorted} />;
}
